import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormFieldList, SfUtils, SmartFormComponent } from 'ngx-smart-form';
import { SharedModule } from 'src/app/_shared/shared.module';
import { BudgetDetails } from 'src/interfaces/budget-details';
import { BudgetDetailsService } from '../../_core/services/budget-details.service';
import { DialogService } from '../../_core/services/dialog.service';
import { PraticaProgressService } from '../../_core/services/pratica-progress.service';
import { getBudgetDataFields } from './budget-details-fields';

@Component({
  standalone: true,
  selector: 'app-budget-details-dialog',
  templateUrl: './budget-details-dialog.component.html',
  styleUrls: ['./budget-details-dialog.component.scss'],
  imports: [SharedModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BudgetDetailsDialogComponent implements AfterViewInit {
  @ViewChildren(SmartFormComponent)
  budgetDataFormComponentList?: QueryList<SmartFormComponent<BudgetDetails>>;

  @ViewChildren('budgetDataList')
  budgetDataList?: QueryList<ElementRef<HTMLElement>>;

  fieldList: {
    fields: FormFieldList<BudgetDetails>;
    label: string;
    key: string;
    id: string | undefined;
  }[] = [];

  public hasSaved = false;

  constructor(
    private cdr: ChangeDetectorRef,
    public praticaProgressService: PraticaProgressService,
    private budgetDetailsService: BudgetDetailsService,
    private dialogService: DialogService,
    public dialogRef: MatDialogRef<BudgetDetailsDialogComponent, boolean>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      uploadedBudgetData: BudgetDetails[];
      idScheda: string;
    }
  ) {}
  ngOnInit() {
    this.fieldList =
      this.data.uploadedBudgetData?.map((el) => {
        return {
          label: el.label,
          key: el.name!,
          fields: getBudgetDataFields(el, el.name!),
          id: el.id,
        };
      }) || [];
    this.cdr.detectChanges();
  }

  ngAfterViewInit(): void {
    this.budgetDataFormComponentList?.forEach((c) => {
      c.form.markAllAsTouched();
    });
    this.cdr.detectChanges();
  }

  save(i: number) {
    if (!this.budgetDataFormComponentList) return;
    let val = this.budgetDataFormComponentList.get(i)?.formValue;
    if (!val) return;
    let field = this.fieldList[i];
    let dato = this.data.uploadedBudgetData[i];
    let id = field.id;
    let oldCurrent = SfUtils.getField('current', field.fields)?.value;
    let oldPrevious = SfUtils.getField('previus', field.fields)?.value;
    let budgetDetails: Partial<BudgetDetails> = {
      label: field.label,
      name: field.key,
      modificatoCorrente: oldCurrent !== val.current,
      modificatoPrecedente: oldPrevious !== val.previus,
      order: dato.order,
      annoCorrente: dato.annoCorrente,
      annoPrecedente: dato.annoPrecedente,
      categoria: dato.categoria,
      visibile: dato.visibile,
      ...val,
    };
    this.hasSaved = true;
    let request$ = id
      ? this.budgetDetailsService.edit(budgetDetails, id, this.data.idScheda)
      : this.budgetDetailsService.add(budgetDetails, this.data.idScheda);

    request$.subscribe((_) => {
      this.dialogService.onSuccess();
    });
  }
}
